/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import CancelAction from './CancelAction/index'
import Confirm from './Confirm/index'
import DataVaxiomPatientInsuranceForm from 'DesignSystem/DataVaxiomPatientInsuranceForm/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsurancePlan/Content/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 width={600}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="View insurance details"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
>
{childProps => (
<DataVaxiomPatientInsuranceForm
{...childProps}
  viewPath={`${viewPath}/DataVaxiomPatientInsuranceForm`}
/>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SaveAction
{...childProps}
  viewPath={`${viewPath}/SaveAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
<Confirm
  viewPath={`${viewPath}/Confirm`}
/>
{children}
</React.Fragment>)
}